import React                      from 'react'


// NOTE: Reason why we cannot use external file is the "currentColor" that appears in stroke.
// This means that the color of the icon is the one of the parent-container, which means,
// that if it is used under a Button, it changes the color as the mouse hovers.
export const KeyIcon: React.FC = ( ) =>
<svg
   xmlns="http://www.w3.org/2000/svg"
   x="0px"
   y="0px"
   width="1em"
   height="1em"
   viewBox="0 0 18 18"
>
  <g transform="matrix(0.38019273,0,0,0.4145206,-3.916882,-3.9191124)">
    <path
      stroke="currentColor"
      fill="none"
      strokeMiterlimit="10"
      d="m 25.444542,18.742113 0,-1.593 c 0,0 -0.07117,-0.549 0.802438,-0.888 0.868695,-0.335 1.803645,-0.92 3.768023,-0.92 1.960699,0 4.171697,1.13 4.171697,1.13 0,0 0.316559,0.087 0.316559,0.373 l 0,1.618 c 0,0 0.106746,0.876 -1.139855,0.876 l -7.159368,0 c 0,0 -0.759494,0.032 -0.759494,-0.596 z"
      strokeWidth="2.5"
    />
    <path
      stroke="currentColor"
      fill="none"
      strokeWidth="2.5"
      strokeLinejoin="round"
      strokeMiterlimit="10"
      d="m 35.322855,40.84765 c -3.419796,-1.207465 -4.817227,-3.917559 -4.841925,-6.369626 -0.0247,-2.452066 1.832125,-5.2138 4.808756,-6.097981 l 0,-3.420819 5.26049,-2.236319 c -0.02944,-2.535244 0.10668,-5.818792 0,-8.348486 -2.603379,-1.515656 -9.205858,-3.382648 -10.52098,-3.730954 -1.315122,0.287511 -7.623075,2.14294 -10.52098,3.693048 l 0,8.386392 5.26049,2.308691 0,22.845668 4.213467,3.639958 6.274344,-4.121367 z"
    />
    <path
      stroke="currentColor"
      fill="none"
      strokeWidth="1"
      d="m 43.323994,36.086744 0.868178,-1.173145 -0.645746,-0.234629 0.416387,-1.399285 -0.688847,0.0039 -0.0862,-1.460258 -0.646515,0.240032 -0.577246,-1.342171 -0.526449,0.446876 -1.003639,-1.062005 -0.34019,0.600465 -1.303037,-0.652948 -0.115449,0.679189 -1.446964,-0.168253 0.124685,0.679189 -1.420025,0.338051 0.348656,0.595834 -1.216835,0.804994 0.527988,0.441473 -0.867408,1.173917 0.645746,0.233857 -0.415618,1.398513 0.686539,-0.0015 0.0862,1.457942 0.644976,-0.240032 0.577246,1.342943 0.527988,-0.449191 1.002869,1.061233 0.338651,-0.59815 1.304576,0.655264 0.11391,-0.680733 1.450812,0.169797 -0.125454,-0.680733 1.419255,-0.338823 -0.347117,-0.597378 1.216065,-0.804993 -0.527987,-0.439158 z m -5.931012,-1.331365 c 0,-1.145361 0.925902,-2.070756 2.065771,-2.070756 1.139869,0 2.063463,0.924624 2.063463,2.070756 0,1.141501 -0.923594,2.071527 -2.063463,2.071527 -1.139869,0 -2.065771,-0.928483 -2.065771,-2.071527 z"
      strokeMiterlimit="10"
    />
  </g>
</svg>

